import styled from "styled-components";

const width = ({ size }) => {
  switch (size) {
    case "1xl":
      return "128px";
    case "xl":
      return "64px";
    case "lg":
      return "32px";
    case "s":
    case "sm":
      return "20px";
    case "xs":
      return "16px";
    case "1xs":
      return "10px";

    case "md":
    default:
      return "24px";
  }
};

export const Wrapper = styled.span`
  width: ${width};
  height: ${width};
  display: grid;
  place-content: center;

  cursor: ${({ onClick }) => (onClick ? "pointer" : "all")};

  svg {
    width: ${width};
    height: ${width};
  }
`;
